module.exports = __webpack_public_path__ + "img/4.5cd35595.png";